import { ContentContainer, Text } from '@ahc-digital/component-library';
import { Text as JSSText } from '@sitecore-jss/sitecore-jss-nextjs';
import Script from 'next/script';
import { I20GenesysWebMessagingProps } from './I20GenesysWebMessaging.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';

export const Default = (props: I20GenesysWebMessagingProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const isEditing = context?.pageEditing ?? false;

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <ContentContainer>
          <Text tag="p" fontStyle="smParagraphBold">
            Business Unit:
          </Text>
          <br />
          <JSSText field={props?.fields?.BusinessUnit} />
          <Text tag="p" fontStyle="smParagraphBold">
            Deployment ID:
          </Text>
          <br />
          <JSSText field={props?.fields?.DeploymentID} />
        </ContentContainer>
      </SwitchToPreviewMessage>
    );
  }

  const deploymentId = props?.fields?.DeploymentID?.value;
  const businessUnit = props?.fields?.BusinessUnit?.value;

  if (!deploymentId && !businessUnit) {
    return <></>;
  }

  return (
    <>
      <Script id="genesys-chat">
        {`
          ;(function (g, e, n, es, ys) {
            g['_genesysJs'] = e;
            g[e] = g[e] || function () {
              (g[e].q = g[e].q || []).push(arguments)
            };
            g[e].t = 1 * new Date();
            g[e].c = es;
            ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);
          })(window, 'Genesys', 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js', {
            environment: 'prod-usw2',
            deploymentId: '${deploymentId}'
          });

          function setgenesyschatvalue() {
            Genesys('subscribe', 'Database.ready', () => {
              Genesys('command', 'Database.set', {
                messaging: {
                  customAttributes: {
                    "BU":"${businessUnit}"
                  }
                }
              });
            });
          }
          Genesys('subscribe', 'MessagingService.ready', () => {
            Genesys('subscribe', 'MessagingService.resetConversation', setgenesyschatvalue);
            Genesys('subscribe', 'MessagingService.conversationCleared', setgenesyschatvalue);
            Genesys('subscribe', 'MessagingService.conversationReset', setgenesyschatvalue);
          });

          Genesys('subscribe', 'Messenger.ready', () => {
            //only launch proactively when messenger does not take up full screen
            if (!window.__genesysMessengerReadySubscribed && !window.matchMedia('(max-width:600px)').matches) {
              window.setTimeout(() => Genesys('command', 'Messenger.open'), 30000);
              window.__genesysMessengerReadySubscribed = true;
            }
          });

          setgenesyschatvalue();
        `}
      </Script>
    </>
  );
};
